import type {
  CreateAdjustmentRequestDto,
  CreateBillingFolioRequestDto,
  CreateRefundRequestDto,
  GenerateBillingInvoiceRequestDto,
  PostFolioChargeRequestDto,
  SettleFolioBalanceRequestDto,
} from "./contracts/dtos.ts";
import type { FiscalIntegrationProvider } from "./fiscal.ts";
import type { BillingInvoiceProvider } from "./invoice.ts";
import {
  createAdjustment,
  createBillingFolio,
  createRefund,
  generateBillingInvoice,
  postFolioCharge,
  settleFolioBalance,
} from "./service.ts";
import type { BillingContext } from "./types.ts";

export const billingManagementEndpoints = {
  createFolio: (
    request: CreateBillingFolioRequestDto,
    context: BillingContext,
    deps: { idFactory: (prefix: string) => string }
  ) => createBillingFolio(request, context, deps),
  postCharge: (
    request: PostFolioChargeRequestDto,
    context: BillingContext,
    deps: { idFactory: (prefix: string) => string }
  ) => postFolioCharge(request, context, deps),
  settleFolio: (
    request: SettleFolioBalanceRequestDto,
    context: BillingContext,
    deps: { idFactory: (prefix: string) => string }
  ) => settleFolioBalance(request, context, deps),
  refundPayment: (
    request: CreateRefundRequestDto,
    context: BillingContext,
    deps: { idFactory: (prefix: string) => string }
  ) => createRefund(request, context, deps),
  adjustFolio: (
    request: CreateAdjustmentRequestDto,
    context: BillingContext,
    deps: { idFactory: (prefix: string) => string }
  ) => createAdjustment(request, context, deps),
  generateInvoice: (
    request: GenerateBillingInvoiceRequestDto,
    context: BillingContext,
    deps: {
      idFactory: (prefix: string) => string;
      invoiceProvider: BillingInvoiceProvider;
      fiscalProvider: FiscalIntegrationProvider;
    }
  ) => generateBillingInvoice(request, context, deps),
};
